import React from 'react';
import AnimatedModal from '../ui/AnimatedModal';
import { XMarkIcon, ShieldCheckIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const DPA_SUPPORT_MAILTO = (() => {
  const to = 'support@talentcrux.ai';
  const subject = 'DPA Request - Enable Document Collection';
  const body = [
    'Hi TalentCrux Support,',
    '',
    'We would like to enable document collection for our workspace on TalentCrux. Please share the Data Processing Agreement (DPA) and the steps to complete it under the DPDP Act.',
    '',
    'Thank you.',
  ].join('\n');
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
})();

export default function DpaRequiredModal({ isOpen, onClose }) {
  return (
    <AnimatedModal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabelledBy="dpa-required-title"
      contentClassName="w-full max-w-4xl bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh]"
      backdropClassName="bg-black/50"
    >
      <div className="flex items-start justify-between flex-shrink-0 px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-slate-50 via-white to-slate-50">
        <div className="flex items-start gap-3">
          <div className="p-2.5 rounded-full bg-blue-50 text-blue-700 shrink-0">
            <ShieldCheckIcon className="h-5 w-5" />
          </div>
          <div className="space-y-1">
            <h3 id="dpa-required-title" className="text-lg font-semibold text-gray-900 tracking-tight">
              Data Processing Agreement Required
            </h3>
            <p className="text-sm text-gray-600 max-w-2xl">
              To use document collection, your organization needs a signed Data Processing Agreement (DPA)
              on file. This is a one-time requirement under India&apos;s DPDP Act.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>

      <div className="overflow-y-auto px-6 py-6 bg-slate-50/60">
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <p className="text-sm text-slate-700">
            Please contact our support team to complete the DPA and enable document collection for your workspace.
          </p>
          <div className="mt-4 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                Support email
              </div>
              <div className="text-sm font-semibold text-slate-900 truncate">support@talentcrux.ai</div>
              <div className="text-xs text-slate-500 truncate">
                We&apos;ll share the next steps and the DPA document with you.
              </div>
            </div>
            <a
              href={DPA_SUPPORT_MAILTO}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#007BFF] text-white text-sm font-semibold hover:bg-[#0a66d6] whitespace-nowrap"
            >
              <EnvelopeIcon className="h-4 w-4" />
              Email support
            </a>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-end gap-3 px-6 py-4 bg-white border-t border-gray-100">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
        >
          Close
        </button>
      </div>
    </AnimatedModal>
  );
}

